// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ContentFilter, ContentFilterT, verifyContentFilter } from "./content-filter";
import {
  SimpleAttributeOperand,
  SimpleAttributeOperandT,
  verifySimpleAttributeOperand,
} from "./simple-attribute-operand";

/**
 * Event filter: which fields to select and an optional where-clause.
 */
export class EventFilter implements flatbuffers.IUnpackableObject<EventFilterT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EventFilter {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEventFilter(bb: flatbuffers.ByteBuffer, obj?: EventFilter): EventFilter {
    return (obj || new EventFilter()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsEventFilter(
    bb: flatbuffers.ByteBuffer,
    obj?: EventFilter,
  ): EventFilter {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new EventFilter()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  selectClauses(index: number, obj?: SimpleAttributeOperand): SimpleAttributeOperand | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new SimpleAttributeOperand()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  selectClausesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  whereClause(obj?: ContentFilter): ContentFilter | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new ContentFilter()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startEventFilter(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addSelectClauses(builder: flatbuffers.Builder, selectClausesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, selectClausesOffset, 0);
  }

  static createSelectClausesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startSelectClausesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addWhereClause(builder: flatbuffers.Builder, whereClauseOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, whereClauseOffset, 0);
  }

  static endEventFilter(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // select_clauses
    return offset;
  }

  unpack(): EventFilterT {
    return new EventFilterT(
      this.bb!.createObjList<SimpleAttributeOperand, SimpleAttributeOperandT>(
        this.selectClauses.bind(this),
        this.selectClausesLength(),
      ),
      this.whereClause() !== null ? this.whereClause()!.unpack() : null,
    );
  }

  unpackTo(_o: EventFilterT): void {
    _o.selectClauses = this.bb!.createObjList<SimpleAttributeOperand, SimpleAttributeOperandT>(
      this.selectClauses.bind(this),
      this.selectClausesLength(),
    );
    _o.whereClause = this.whereClause() !== null ? this.whereClause()!.unpack() : null;
  }

  unpackFields(...fields: string[]): EventFilterT {
    const t = new EventFilterT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("select_clauses")) {
      t.selectClauses = this.bb!.createObjList<SimpleAttributeOperand, SimpleAttributeOperandT>(
        this.selectClauses.bind(this),
        this.selectClausesLength(),
      );
    }
    if (fieldSet.has("where_clause")) {
      t.whereClause = this.whereClause() !== null ? this.whereClause()!.unpack() : null;
    }
    return t;
  }
}

export class EventFilterT implements flatbuffers.IGeneratedObject {
  constructor(
    public selectClauses: SimpleAttributeOperandT[] = [],
    public whereClause: ContentFilterT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.selectClauses === null || this.selectClauses === undefined) {
      throw new Error('Required field "select_clauses" is not set');
    }
    const selectClauses = EventFilter.createSelectClausesVector(
      builder,
      builder.createObjectOffsetList(this.selectClauses),
    );
    const whereClause = this.whereClause !== null ? this.whereClause!.pack(builder) : 0;

    EventFilter.startEventFilter(builder);
    EventFilter.addSelectClauses(builder, selectClauses);
    EventFilter.addWhereClause(builder, whereClause);

    return EventFilter.endEventFilter(builder);
  }

  clone(): EventFilterT {
    const obj = new EventFilterT();
    obj.selectClauses = this.selectClauses.map((e) => e.clone());
    obj.whereClause = this.whereClause !== null ? this.whereClause!.clone() : null;
    return obj;
  }

  equals(other: EventFilterT): boolean {
    if (this.selectClauses.length !== other.selectClauses.length) return false;
    for (let i = 0; i < this.selectClauses.length; i++) {
      const a = this.selectClauses[i];
      const b = other.selectClauses[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.whereClause !== null && other.whereClause !== null) {
      if (!this.whereClause!.equals(other.whereClause!)) return false;
    } else if (this.whereClause !== other.whereClause) return false;
    return true;
  }
}

export function verifyEventFilter(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySimpleAttributeOperand);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "select_clauses");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyContentFilter(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
